import { translate } from '_common/utils/language';

import getBase1 from './P_BASE';

function P3_PHOTO() {
  const base = getBase1();
  const template = [
    {
      title: translate('jp.verification.guardian.form.title1'),
      form: {
        idCard: base.idCard,
        expirationDate: base.expirationDate,
      },
    },
  ];
  return template;
}

export default P3_PHOTO;
